module.exports = __webpack_public_path__ + "img/kjjh_gallery0.656ea84a.jpg";